export const currencyFormat = (
  amount,
  locale = "id-ID",
  options = {
    currency: "IDR",
    currencyDisplay: "symbol",
    currencySign: "standard",
    minimumFractionDigits: 0,
  },
  customOptions = {
    addDotAfterRupiah: false,
    removeSpaceAfterRp: true,
    removeRupiah: false,
  }
) => {
  const opts = {
    style: "currency",
    currency: "IDR",
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
    ...options,
  }
  const formatted = new Intl.NumberFormat(locale, opts).format(amount);

  if (customOptions.addDotAfterRupiah) {
    return formatted.replace("Rp", "Rp.");
  }

  if (customOptions.removeSpaceAfterRp) {
    return formatted.replace(/^Rp\s/, "Rp");
  }

  if (customOptions.removeRupiah) {
    return formatted.replace(/^Rp\s/, "");
  }

  return formatted;
};

export const formatIndonesianKMBT = (n, kmbt, c = 1) => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(c) + `${kmbt.k}`;
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(c) + `${kmbt.m}`;
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(c) + `${kmbt.b}`;
  if (n >= 1e12) return +(n / 1e12).toFixed(c) + `${kmbt.t}`;
};

/**
 * @docs https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
 */
export const currency = (
  _amount,
  _options = {
    locale: "id-ID",
    currency: "IDR",
    currencyDisplay: "symbol",
    currencySign: "standard",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    // custom
    removeSymbol: false,
    removeSpaceAfterSymbol: false,
    addDotAfterSymbol: false,
  },
) => {
  const options = {
    style: "currency",
    locale: "id-ID",
    currency: "IDR",
    currencyDisplay: "symbol",
    currencySign: "standard",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    // custom
    removeSymbol: false,
    removeSpaceAfterSymbol: false,
    addDotAfterSymbol: false,
    ..._options,
  }

  let formatted = new Intl.NumberFormat(options.locale, options).format(_amount);

  if (options.addDotAfterSymbol) {
    formatted = formatted.replace("Rp", "Rp.");
  }

  if (options.removeSpaceAfterSymbol) {
    formatted = formatted.replace(/^Rp\s/, "Rp");
  }

  if (options.removeSymbol) {
    formatted = formatted.replace(/^Rp\s/, "");
  }

  return formatted;
};